import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { cn } from "$lib/utils.js";

var root = $.from_html(`<div><!></div>`);

export default function Card_header($$anchor, $$props) {
	$.push($$props, true);

	let ref = $.prop($$props, 'ref', 15, null),
		restProps = $.rest_props($$props, [
			'$$slots',
			'$$events',
			'$$legacy',
			'ref',
			'class',
			'children'
		]);

	var div = root();

	$.attribute_effect(div, ($0) => ({ 'data-slot': 'card-header', class: $0, ...restProps }), [
		() => cn("@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6", $$props.class)
	]);

	var node = $.child(div);

	$.snippet(node, () => $$props.children ?? $.noop);
	$.reset(div);
	$.bind_this(div, ($$value) => ref($$value), () => ref());
	$.append($$anchor, div);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiY2FyZC1oZWFkZXIuc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQgbGFuZz1cInRzXCI+XG5cdGltcG9ydCB7IGNuLCB0eXBlIFdpdGhFbGVtZW50UmVmIH0gZnJvbSBcIiRsaWIvdXRpbHMuanNcIjtcblx0aW1wb3J0IHR5cGUgeyBIVE1MQXR0cmlidXRlcyB9IGZyb20gXCJzdmVsdGUvZWxlbWVudHNcIjtcblxuXHRsZXQge1xuXHRcdHJlZiA9ICRiaW5kYWJsZShudWxsKSxcblx0XHRjbGFzczogY2xhc3NOYW1lLFxuXHRcdGNoaWxkcmVuLFxuXHRcdC4uLnJlc3RQcm9wc1xuXHR9OiBXaXRoRWxlbWVudFJlZjxIVE1MQXR0cmlidXRlczxIVE1MRGl2RWxlbWVudD4+ID0gJHByb3BzKCk7XG48L3NjcmlwdD5cblxuPGRpdlxuXHRiaW5kOnRoaXM9e3JlZn1cblx0ZGF0YS1zbG90PVwiY2FyZC1oZWFkZXJcIlxuXHRjbGFzcz17Y24oXG5cdFx0XCJAY29udGFpbmVyL2NhcmQtaGVhZGVyIGdyaWQgYXV0by1yb3dzLW1pbiBncmlkLXJvd3MtW2F1dG9fYXV0b10gaXRlbXMtc3RhcnQgZ2FwLTEuNSBweC02IGhhcy1kYXRhLVtzbG90PWNhcmQtYWN0aW9uXTpncmlkLWNvbHMtWzFmcl9hdXRvXSBbLmJvcmRlci1iXTpwYi02XCIsXG5cdFx0Y2xhc3NOYW1lXG5cdCl9XG5cdHsuLi5yZXN0UHJvcHN9XG4+XG5cdHtAcmVuZGVyIGNoaWxkcmVuPy4oKX1cbjwvZGl2PlxuIl0sIm1hcHBpbmdzIjoiOztTQUNVLEVBQUUsUUFBNkIsZUFBZTs7Ozt1REFEeEQsQ0FBQzs7O0tBS0MsR0FBRyw4QkFBYSxJQUFJO0VBR2pCLFNBQVM7Ozs7Ozs7Ozs7OzhFQVdULFNBQVM7UUFKTixFQUFFLENBQ1IsNEpBQTRKOzs7Ozs7OytCQUhsSixHQUFHLGlCQUFILEdBQUc7OztBQUhoQixDQUFDIn0=